<template>
	<div>
		<div class="public-table-but__left">
			<div class="item">
				<!-- <em>筛选：</em> -->
				<div class="item-wp">
					<!-- 搜索 -->
					<template v-if="searchShow">
						<div class="item-son">
							<el-input
								v-model="listParams.searchKey"
								placeholder="搜索关键词"
								clearable
								@keyup.enter.native="SearchQuestionBankList"
							></el-input>
						</div>
						<div class="item-son">
							<el-select
								v-model="dictDataSelect"
								placeholder="请选择分类"
								ref="selectReport"
								style="width: 100%"
								clearable
							>
								<el-option
									:value="listParams.categoryId"
									:label="listParams.categoryId"
									style="height: auto"
								>
									<el-tree
										:data="selectData"
										:props="treeProps"
										:render-after-expand="true"
										:expand-on-click-node="false"
										@node-click="handleNodeClick"
									></el-tree>
								</el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-select
								v-model="listParams.status"
								clearable
								placeholder="请选择状态"
								style="width: 120px"
							>
								<el-option label="正常" :value="1"></el-option>
								<el-option label="禁用" :value="0"></el-option>
							</el-select>
						</div>
						<div class="item-son">
							<el-button type="primary" @click="SearchQuestionBankList"
								>查询 <i class="el-icon-search"></i>
							</el-button>
						</div>
					</template>
					<!-- 新增 -->
					<div class="item-son" v-if="addShow">
						<el-button type="primary" @click="handleClick('add')"
							>新增 <img src="@assets/images/add-icon.png" alt="" />
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="public-table-data">
			<el-table
				ref="multipleTable"
				size="medium"
				:data="tableData"
				border
				style="width: 100%"
				row-key="menuId"
				v-loading="loading"
			>
				<el-table-column
					fixed="left"
					type="index"
					label="序号"
					width="60"
					align="center"
				>
				</el-table-column>
				<el-table-column
					fixed="left"
					prop="name"
					label="名称"
					min-width="230"
					align="center"
				>
				</el-table-column>
				<el-table-column prop="examId" label="标识" width="150" align="center">
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="分类"
					width="150"
					align="center"
				>
					<template slot-scope="scope">
						<div>
							{{ scope.row.categoryName1 }}-{{ scope.row.categoryName }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="题目"
					width="180"
					align="center"
				>
					<template slot-scope="scope">
						<div>维度：{{ scope.row.dimensions }}</div>
						<div>题目：{{ scope.row.questions }}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="categoryName"
					label="数据"
					width="180"
					align="center"
				>
					<template slot-scope="scope">
						<div>参与：{{ scope.row.answers }}</div>
						<div>购买：{{ scope.row.buys }}</div>
					</template>
				</el-table-column>

				<el-table-column
					prop="payPrice"
					label="支付价"
					width="120"
					align="center"
				>
					<template slot-scope="scope">
						{{ `$ ${formatMinNum(scope.row.payPrice)}` }}
					</template>
				</el-table-column>

				<el-table-column prop="code" label="状态" width="100" align="center">
					<template slot-scope="scope">
						<el-switch
							:disabled="statusShow"
							v-model="scope.row.status"
							:active-value="1"
							:inactive-value="0"
							@change="changeSwitch(scope.row)"
						>
						</el-switch>
					</template>
				</el-table-column>

				<el-table-column
					prop="issuedTime"
					label="上架时间"
					width="180"
					align="center"
				>
				</el-table-column>

				<el-table-column
					fixed="right"
					label="操作"
					align="center"
					width="280"
					min-width="200"
				>
					<template slot-scope="scope">
						<el-button
							v-if="editShow"
							style="margin-bottom: 10px"
							size="mini"
							@click="handleClick('edit', scope.row)"
							type="success"
							plain
							>编辑
						</el-button>
						<el-button
							v-if="questionShow"
							size="mini"
							@click="handleClick('topic', scope.row)"
							type="warning"
							plain
							>题目
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('explain', scope.row)"
							type="warning"
							plain
							v-if="introShow"
							>说明
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('style', scope.row)"
							type="primary"
							plain
							v-if="styleShow"
							>样式
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('grouping', scope.row)"
							type="primary"
							style="margin: 0"
							plain
							>权益
						</el-button>
						<el-button
							size="mini"
							@click="handleClick('programme', scope.row)"
							type="success"
							plain
							>方案
						</el-button>
						<el-button
							size="mini"
							@click="copyHandleClickShow(scope.row)"
							type="success"
							plain
							v-if="copyShow"
							>复制
						</el-button>
						<el-popover trigger="hover" placement="bottom" width="180px">
							<template>
								<el-button
									size="mini"
									@click="shareHandleClick(scope.row)"
									type="primary"
									style="margin: 0"
									plain
									v-if="shareShow"
									>分享
								</el-button>
								<el-button
									size="mini"
									@click="handleClick('ziyuan', scope.row)"
									type="warning"
									plain
									>资源
								</el-button>
								<el-button
									size="mini"
									@click="configureHandleClick(scope.row)"
									type="primary"
									plain
									v-if="configureShow"
									>配置
								</el-button>
								<el-button
									size="mini"
									@click="copyHandleClickShow(scope.row)"
									type="success"
									plain
									v-if="copyShow"
									>复制
								</el-button>
								<el-button
									size="mini"
									@click="handleClick('time', scope.row)"
									type="success"
									plain
									v-if="timeShow"
									>时间
								</el-button>
								<template v-if="userInfo && userInfo.operateStatus == 1">
									<el-button
										size="mini"
										@click="handleDelete(scope.row)"
										type="danger"
										plain
										v-if="numType && deleteShow"
										>删除
									</el-button>
									<el-button
										size="mini"
										@click="operationShowTime"
										type="danger"
										plain
										v-if="!numType && deleteShow"
										>删除
									</el-button>
								</template>
							</template>
							<el-button
								slot="reference"
								class="name-wrapper"
								size="mini"
								type="success"
								plain
								style="margin-left: 10px"
								>更多
							</el-button>
						</el-popover>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<div class="public-pagination">
				<el-pagination
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="pages.pageNo"
					:page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
					:page-size="pages.pageSize"
					layout="total, sizes, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
		<!-- 复制弹框 -->
		<el-dialog
			title="复制测评"
			:visible.sync="copyDialogVisible"
			width="360px"
			top="30px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<div class="item_info">
					<div class="name_left">分类：</div>
					<div>{{ copyInfo.categoryName1 }}-{{ copyInfo.categoryName }}</div>
				</div>
				<div
					style="
						display: flex;
						align-items: center;
						justify-content: space-between;
					"
				>
					<div class="item_info">
						<div class="name_left">名称：</div>
						<div>{{ copyInfo.name }}</div>
					</div>
					<div class="item_info">
						<div class="name_left">标识：</div>
						<div>{{ copyInfo.examId }}</div>
					</div>
				</div>

				<div class="item_info">
					<div class="name_left">新标识：</div>
					<div>
						<el-input v-model="copyInput" placeholder="请输入内容"></el-input>
					</div>
				</div>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="copyDialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="copyHandleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 编辑弹框 -->
		<el-dialog
			title="新增/编辑评测题信息"
			:visible.sync="dialogVisible"
			width="860px"
			top="30px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<div class="public-dialog-form">
				<el-form
					ref="ruleForm"
					:rules="rules"
					:model="params"
					label-width="80px"
				>
					<el-tabs
						type="card"
						v-model="languageCode"
						@tab-click="handleTabClick"
					>
						<el-tab-pane
							v-for="(item, index) in languageList"
							:label="item.name"
							:name="item.code"
							:key="index"
						></el-tab-pane>
					</el-tabs>
					<el-form-item prop="paymentType" label="分类">
						<el-select
							v-model="dictDataSelect1"
							placeholder="请选择分类"
							ref="selectReport"
							style="width: 100%"
							clearable
						>
							<el-option
								:value="params.categoryId"
								:label="params.categoryId"
								style="height: auto"
							>
								<el-tree
									:data="selectData"
									:props="treeProps"
									:render-after-expand="true"
									:expand-on-click-node="false"
									@node-click="handleNodeClick1"
								></el-tree>
							</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="列表图">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcList"
									:key="index"
									class="slideshow"
								>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicy"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicy"
									v-if="isMoer"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="file"
								@change="getFile"
								accept="image/png,image/jpg"
							/>
						</div>

						<div class="diplay" style="margin-right: 50px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcListLang"
									:key="index"
									class="slideshow"
								>
									<el-image
										style="width: 150px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicyLang"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 150px; height: 75px; line-height: 80px"
									@click="getPolicyLang"
									v-if="isMoerLang"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="fileLang"
								@change="getFileLang"
								accept="image/png,image/jpg"
							/>
						</div>

						<div class="diplay">
							<span class="video-label">视频</span>
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcListVideo"
									:key="index"
									class="slideshow"
								>
									<div @click="getPolicyVideo">
										<video
											width="100%"
											controls="controls"
											style="width: 75px; height: 75px; border-radius: 6px"
										>
											<source :src="imgUrl" type="video/mp4" />
										</video>
									</div>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicyVideo"
									v-if="isMoerVideo"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="fileVideo"
								@change="getFileVideo"
								accept="video/*"
							/>
						</div>
					</el-form-item>

					<el-form-item label="轮播图">
						<div class="diplay" style="margin-right: 10px">
							<div class="screenshot">
								<span
									v-for="(imgUrl, index) in srcListBanner"
									:key="index"
									class="slideshow"
								>
									<div class="icon-close" @click="removeUploading(index)">
										<i class="el-icon-close"></i>
									</div>
									<el-image
										style="width: 75px; height: 75px; border-radius: 6px"
										:src="imgUrl"
										fit="cover"
										@click="getPolicyBanner"
									/>
								</span>
								<div
									class="up-btn"
									style="width: 75px; height: 75px; line-height: 80px"
									@click="getPolicyBanner"
								>
									<i class="el-icon-plus"></i>
								</div>
							</div>
							<input
								type="file"
								ref="fileBanner"
								@change="getFileBanner"
								accept="image/png,image/jpg"
							/>
						</div>
					</el-form-item>

					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="名称" prop="name">
								<el-input
									placeholder="请填写名称"
									v-model="params.name"
									style="width: 234px"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="标识" prop="examId">
								<el-input
									placeholder="请填写标识"
									v-model="params.examId"
									:disabled="clickType == 'edit'"
									style="width: 234px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-form-item label="支付说明">
						<el-input placeholder="请填写支付说明" v-model="params.feeDescr">
						</el-input>
					</el-form-item>

					<el-form-item label="主题" prop="subject">
						<el-input
							type="textarea"
							:autosize="{ minRows: 3, maxRows: 4 }"
							placeholder="请填写主题"
							v-model="params.subject"
						>
						</el-input>
					</el-form-item>

					<el-row type="flex">
						<el-col :span="12">
							<el-form-item label="支付价" prop="payPrice">
								<el-input
									placeholder="请填写支付价"
									v-model="params.payPrice"
									style="width: 160px"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="原价" prop="rawPrice">
								<el-input
									placeholder="请填写原价"
									v-model="params.rawPrice"
									style="width: 160px"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row type="flex">
						<el-col :span="6">
							<el-form-item label="VIP免费">
								<el-switch
									v-model="params.vipFree"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="推荐会员">
								<el-switch
									v-model="params.recomVip"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="免费测试">
								<el-switch
									v-model="params.free"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="错题集">
								<el-switch
									v-model="params.resultStatus"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="6">
							<el-form-item label="最热">
								<el-switch
									v-model="params.isHot"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="推荐">
								<el-switch
									v-model="params.isRecommended"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="主页banner推荐">
								<el-switch
									v-model="params.isBanner"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="公式">
								<el-input
									placeholder="请填写公式"
									v-model="params.formula"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="类别">
								<el-input
									placeholder="请填写类别"
									v-model="params.category"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="数据点">
								<el-input
									placeholder="请填写数据点"
									v-model="params.dataPoint"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="全球已测">
								<el-input
									placeholder="请填写全球已测"
									v-model="params.globalNum"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="昨日已测">
								<el-input
									placeholder="请填写昨日已测"
									v-model="params.yesterdayCount"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="平均分">
								<el-input
									placeholder="请填写平均分"
									v-model="params.examAvgScore"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="昨日分数">
								<el-input
									placeholder="请填写昨日分数"
									v-model="params.yesterdayScore"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row type="flex">
						<el-col :span="6">
							<el-form-item label="结果PDF">
								<el-switch
									v-model="params.resultPdf"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="证书PDF">
								<el-switch
									v-model="params.certPdf"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
						<el-col :span="6">
							<el-form-item label="三次赠送">
								<el-switch
									v-model="params.giftStatus"
									:active-value="1"
									:inactive-value="0"
								>
								</el-switch>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" v-show="['jz', 'wd'].includes(params.scheme)">
						<el-col :span="8">
							<el-form-item label="每页题数">
								<el-input
									placeholder="请输入每页题目数"
									v-model="params.pageQuestionNum"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="左侧文案">
								<el-input
									placeholder="请填写左侧文案"
									v-model="params.leftText"
								></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="右侧文案">
								<el-input
									placeholder="请填写右侧文案"
									v-model="params.rightText"
								></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row type="flex" justify="space-between">
						<el-col :span="14">
							<el-row>
								<el-col :span="16">
									<el-form-item label-width="80px" label="标签" prop="pages">
										<el-input
											v-model="params.pages"
											style="width: 50px"
										></el-input>
										页专业报告，约
									</el-form-item>
								</el-col>
								<el-col :span="8">
									<el-form-item label-width="0px" prop="times">
										<el-input
											v-model="params.times"
											style="width: 50px"
										></el-input>
										分钟
									</el-form-item>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="10">
							<el-form-item prop="scheme" label="解析">
								<el-select
									v-model="params.scheme"
									clearable
									placeholder="请选择解析"
								>
									<el-option label="基于高低分" value="mid"></el-option>
									<el-option label="基于维度" value="wd"></el-option>
									<el-option label="基于基准" value="jz"></el-option>
									<el-option label="基于平均分" value="avg"></el-option>
									<el-option label="基于大五人格" value="dwrg"></el-option>
									<el-option label="基于潜意识" value="qys"></el-option>
									<el-option label="基于基准倾向" value="jzqx"></el-option>
									<el-option label="基于图谱" value="rgtp"></el-option>
									<el-option label="基于评级" value="wdpj"></el-option>
									<el-option label="基于色彩" value="wdsc"></el-option>
									<el-option label="基于二级维度" value="ejwz"></el-option>
									<el-option label="基于暗黑人格" value="ahrg"></el-option>
									<el-option label="基于天才人格" value="tcrg"></el-option>
									<el-option label="基于MBTI" value="mbti"></el-option>
									<el-option label="基于维度年龄" value="wdnl"></el-option>
									<el-option label="基于维度组合" value="wdzh"></el-option>
									<el-option label="基于人格魅力" value="rgml"></el-option>
									<el-option label="基于爱情三元" value="aqsy"></el-option>
									<el-option label="基于马基雅维利" value="mjywl"></el-option>
									<el-option label="基于投资风格" value="tzfg"></el-option>
									<el-option label="基于心理图谱" value="xltp"></el-option>
									<el-option label="基于斯坦福实验" value="stfsy"></el-option>
									<el-option label="基于心理实验" value="xlsy"></el-option>
									<el-option label="基于新智商" value="niq"></el-option>
                				</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-form-item label="详情">
							<richText
								:keyWord="'detail'"
								:params="params"
								v-if="flag"
							></richText>
						</el-form-item>
					</el-row>
				</el-form>
			</div>
			<span slot="footer" class="public-dialog-footer">
				<el-button size="medium" @click="dialogVisible = false"
					>取 消</el-button
				>
				<el-button size="medium" type="primary" @click="handleEdit"
					>提 交</el-button
				>
			</span>
		</el-dialog>
		<!-- 说明列表 -->
		<el-dialog
			title="说明列表"
			:visible.sync="dialogVisibleExplain"
			width="580px;"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<el-dialog
				width="560px"
				title="新增/编辑说明列表"
				:visible.sync="innerVisible"
				append-to-body
				:close-on-click-modal="false"
			>
				<div class="public-dialog-form">
					<el-form
						ref="explainRuleForm"
						:rules="explainRules"
						:model="explainParams"
						label-width="80px"
					>
						<el-form-item label="类型" prop="introType">
							<el-select
								v-model="explainParams.introType"
								clearable
								placeholder="请选择说明类型"
								style="width: 100%"
								@change="select"
							>
								<el-option
									v-for="(item, index) in explainTypeData"
									:key="item.enumVal"
									:label="item.enumName"
									:value="item.enumVal"
								></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="标题" prop="name">
							<el-input
								type="text"
								@input="updateTotal($event)"
								placeholder="请填写标题"
								v-model="explainParams.name"
							>
							</el-input>
						</el-form-item>
						<el-form-item label="详情">
							<richText
								v-if="innerVisible"
								:keyWord="'intro'"
								:params="explainParams ? explainParams : ''"
							></richText>
						</el-form-item>
						<el-form-item label="排序" prop="seq">
							<el-input
								type="text"
								placeholder="请填写序号"
								v-model="explainParams.seq"
							>
							</el-input>
						</el-form-item>
					</el-form>
				</div>
				<span slot="footer" class="public-dialog-footer">
					<el-button size="medium" @click="innerVisible = false"
						>取 消</el-button
					>
					<el-button size="medium" type="primary" @click="handleExplainEdit"
						>提 交</el-button
					>
				</span>
			</el-dialog>
			<el-tabs v-model="activeName" @tab-click="handleClickExplain">
				<el-tab-pane
					v-for="item in explainTypeData"
					:key="item.enumId"
					:label="item.enumName"
					:name="item.enumVal"
				></el-tab-pane>
			</el-tabs>
			<div class="item-add">
				<el-button size="mini" type="primary" @click="handleClick('explainAdd')"
					>新增 <img src="@assets/images/add-icon.png" alt="" />
				</el-button>
				<el-table
					ref="multipleTable"
					size="mini"
					:data="explainData"
					border
					style="width: 100%"
					row-key="menuId"
					v-loading="loading"
				>
					<el-table-column type="index" label="序号" width="50" align="center">
					</el-table-column>
					<el-table-column
						prop="introTypeName"
						label="类型"
						min-width="100"
						align="center"
					>
					</el-table-column>
					<el-table-column
						prop="examInfoId"
						label="测评题ID"
						width="150"
						align="center"
					>
					</el-table-column>
					<el-table-column prop="seq" label="排序" width="80" align="center">
					</el-table-column>
					<el-table-column prop="ctime" label="时间" width="150" align="center">
					</el-table-column>
					<el-table-column label="操作" align="center" min-width="150">
						<template slot-scope="scope">
							<el-button
								size="mini"
								@click="handleClick('explainEdit', scope.row)"
								type="success"
								plain
								>编辑
							</el-button>
							<el-button
								size="mini"
								@click="handleDeleteexplain(scope.row)"
								type="danger"
								plain
								v-if="numType"
								>删除
							</el-button>
							<el-button
								size="mini"
								v-else
								@click="operationShowTime"
								type="danger"
								plain
								>删除
							</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-dialog>
        <!-- 关联样式 -->
		<el-dialog
			title="关联样式"
			:visible.sync="dialogVisibleStyle"
			width="560px"
			:close-on-click-modal="false"
			class="public-dialog"
		>
			<el-form label-width="80px" ref="ruleStyle">
				<el-form-item label="分类">
					<el-input
						type="text"
						placeholder=""
						v-model="paramsClass.class"
						readonly=""
					>
					</el-input>
				</el-form-item>
				<el-form-item label="名称">
					<el-input
						type="text"
						placeholder=""
						v-model="paramsClass.name"
						readonly=""
						style="width: 185px"
					>
					</el-input>
					<span style="margin: 0 12px 0 30px">标识</span>
					<el-input
						type="text"
						placeholder=""
						v-model="paramsClass.iden"
						style="width: 185px"
						readonly=""
					>
					</el-input>
				</el-form-item>

				<el-form-item label="样式">
					<el-tabs
						v-model="paramsClass.styleType"
						@tab-click="handleClickStyle"
					>
						<el-tab-pane label="测评落地页" name="cpzy"></el-tab-pane>
						<el-tab-pane label="测评答题页" name="cpdt"></el-tab-pane>
						<el-tab-pane label="测评结果页" name="cpjg"></el-tab-pane>
					</el-tabs>
					<div class="style_box">
						<div
							class="style-outer"
							v-for="(item, index) in tableDataStyle"
							:key="item.examStyleId"
							@click="selectStyle(item, item.examStyleId)"
						>
							<div class="isCheck">
								<i
									:class="[
										'el-icon-success',
										{ active_class: activeIndex == item.examStyleId },
									]"
								></i>
							</div>
							<el-image
								style="width: 108px; height: 76px"
								:src="item.icon"
								fit="cover"
							></el-image>
							<div class="style__font">{{ item.name }}</div>
						</div>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
		<operation-confirmation
			@closeOperation="publicMethios"
			:operationVisible="operationVisible"
		></operation-confirmation>
	</div>
</template>
<script>
import richText from "../../components/richText.vue";

import { PAGE_SIZE, FILE_ROOT, JOB_STATUS } from "@config";
import { formatMoney } from "@utils/filters/filter";
import { formatMaxNum, formatMinNum, emptyShow } from "@utils/tools/index";
import { ossUpload } from "@utils/filters/upload";
import { isEmpty } from "../../utils/tools";
import OperationConfirmation from "../../components/OperationConfirmation";
import InlineTableControler from '@/components/InlineTableControler.vue';
export default {
	inject: ["reload"],
	filters: {
		payPrice(num) {},
	},
	components: {
		richText,
		OperationConfirmation,
		InlineTableControler
	},
	computed: {
		userInfo() {
			return this.$store.state.userInfo;
		},
	},
	data() {
		return {
			activeIndex: -1, //样式激活的index
			/* 这两个样式在哪里的 临时存储 */
			tempStyle: {
				main: -1,
				res: -1,
			},

			// listParams: {},
			params: {
				vipFree: 0,
			},
			dictDataSelect: "",
			dictDataSelect1: "",
			selectData: [],
			tableData: [],
			formatMoney,
			formatMaxNum,
			formatMinNum,
			emptyShow,
			dialogVisible: false,
			total: 0,
			PAGE_SIZE,
			loading: false,
			pages: {
				pageNo: 1,
				pageSize: PAGE_SIZE,
			},
			explain: {},
			treeProps: {
				//配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
				value: "parentId",
				children: "examCategoryVos",
				label: "name",
			},
			srcList: [],
			isMoer: true,
			srcListLang: [],
			isMoerLang: true,
			srcListVideo: "",
			isMoerVideo: true,
			srcListBanner: [],
			isMoerBanner: true,
			activeName: "",
			dialogVisibleExplain: false,
			innerVisible: false,
			clickType: "",
			explainData: [], //说明列表数据
			explainParams: {
				name: "",
			},
			explainTypeData: [], //获取说明类型数据
			examInfoId: "",
			dialogVisibleStyle: false,
			tableDataStyle: [],
			listParams: {
				styleType: "cpzy",
			},
			paramsClass: {
				styleType: "cpzy",
			},
			rules: {
				logo: [{ required: true, message: "请填写列表图", trigger: "blur" }],
				name: [{ required: true, message: "请填写名称", trigger: "blur" }],
				examId: [{ required: true, message: "请填写标识", trigger: "blur" }],
				subject: [{ required: true, message: "请填写主题", trigger: "change" }],
				scheme: [
					{ required: true, message: "请选择解析方式", trigger: "blur" },
				],
				payPrice: [
					{ required: true, message: "请填写支付价", trigger: "blur" },
				],
				rawPrice: [{ required: true, message: "请填写原价", trigger: "blur" }],
				pages: [{ required: true, message: "请填写页数", trigger: "blur" }],
				times: [{ required: true, message: "请填写所需时间", trigger: "blur" }],
				privateKey: [
					{ required: true, message: "请填写商户秘钥", trigger: "change" },
				],
				domainBizId: [
					{ required: true, message: "请选择回调地址", trigger: "change" },
				],
				domainUri: [
					{ required: true, message: "请填写接口地址", trigger: "change" },
				],
			},
			explainRules: {
				introType: [
					{ required: true, message: "请选择说明类型", trigger: "change" },
				],
				intro: [{ required: true, message: "请填写详情", trigger: "change" }],
				// seq: [{
				//   // required: true,
				//  message: "请填写序号", trigger: "change" }],
			},
			flag: false, //销毁子组件
			operationVisible: false,
			numType: false,
			//添加
			addShow: false,
			//删除
			deleteShow: false,
			//编辑
			editShow: false,
			//状态
			statusShow: true,
			//搜索
			searchShow: false,
			//题目
			questionShow: false,
			//说明
			introShow: false,
			//样式
			styleShow: false,
			//时间
			timeShow: false,
			//配置
			configureShow: false,
			shareShow: false,

			copyShow: false,

			copyDialogVisible: false,

			copyInfo: {},

			copyInput: "",

			languageCode: "",

			languageList: [],
		};
	},
	created() {
		if (window.sessionStorage.getItem("operationKey")) {
			this.numType = true;
		}
		this.classifyData();
		this.queryTableData();
		this.explainType();
		this.queryStyleData();
		this.getPermissionButtonList();
		this.getLanguageList();
	},
	watch: {
		dialogVisible() {
			if (this.dialogVisible == false) {
				this.$refs["ruleForm"].resetFields();
				this.params = {};
				this.dictDataSelect1 = ""; //清空分类

				/* 以下：清空所有图片  */
				this.srcList = [];
				this.isMoer = true;
				this.srcListLang = [];
				this.isMoerLang = true;
				this.srcListVideo = "";
				this.isMoerVideo = true;
				this.srcListBanner = [];
				this.isMoerBanner = true;
			}
		},
		dialogVisibleStyle() {
			if (this.dialogVisibleStyle == false) {
				this.$refs["ruleStyle"].resetFields();
				this.params = {};
				this.activeIndex = -1; //样式激活的index
				/* 这两个样式在哪里的 临时存储 */
				this.tempStyle = {
					main: -1,
					res: -1,
				};
			}
		},
	},
	methods: {
		//获取语言列表
		async getLanguageList() {
			this.loading = true;
			//角色列表
			const { data: res } = await this.$post(`/language/list`, {
				adminStatus: 1,
			});
			this.loading = false;
			this.languageList = res.data;
			this.languageCode = res.data[0].code;
		},
		handleTabClick() {
			this.srcListLang = [];
			this.srcList = [];
			this.isMoer = true;
			this.isMoerLang = true;
			if (this.params.examId) {
				this.getExamDataInfo();
			}
		},
		updateTotal() {
			this.$forceUpdate();
		},
		// 配置
		configureHandleClick(e) {
			this.$router.push({
				name: "CONFIGURE_VIEW",
				query: {
					examId: e.examId,
				},
			});
		},

		copyHandleClickShow(e) {
			this.copyInfo = e;
			this.copyDialogVisible = true;
		},

		copyHandleEdit() {
			if (!this.copyInput) {
				this.$message.error("请输入新的标识");
			} else {
				let obj = {
					examId: this.copyInfo.examId,
					newExamId: this.copyInput,
				};
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					const { data: resData } = await this.$post("/exam/copy/info", obj, {
						headers: {
							isLoading: true,
						},
					});
					if (resData.result != 200) return;
					this.queryTableData();
					this.copyInput = "";
					this.copyDialogVisible = false;
					this.$message.success("复制成功!");
				});
			}
			// console.log(e)
		},

		shareHandleClick(e) {
			this.$router.push({
				name: "SHARE_SET",
				query: {
					examId: e.examId,
				},
			});
		},
		getPermissionButtonList() {
			let PermissionButtonList = window.sessionStorage.getItem(
				"TaotanPermissionButton"
			);
			let arr = JSON.parse(PermissionButtonList);
			if (arr.length) {
				arr.map((item) => {
					if (item.code == "exam:list:question") {
						this.questionShow = true;
					}
					if (item.code == "exam:list:intro") {
						this.introShow = true;
					}
					if (item.code == "exam:list:style") {
						this.styleShow = true;
					}
					if (item.code == "exam:list:time") {
						this.timeShow = true;
					}
					if (item.code == "exam:list:query") {
						this.searchShow = true;
					}
					if (item.code == "exam:list:share") {
						this.shareShow = true;
					}
					if (item.code == "exam:list:add") {
						this.addShow = true;
					}
					if (item.code == "exam:list:delete") {
						this.deleteShow = true;
					}
					if (item.code == "exam:list:edit") {
						this.editShow = true;
					}
					if (item.code == "exam:list:copy") {
						this.copyShow = true;
					}
					if (item.code == "exam:list:status") {
						this.statusShow = false;
					}
					if (item.code == "exam:list:configure") {
						this.configureShow = true;
					}
				});
			}
		},
		//清楚缓存数据，重启密码验证
		clearStore() {
			window.sessionStorage.removeItem("operationKey");
			this.numType = false;
		},
		//关闭
		publicMethios(e) {
			this.operationVisible = false;
			if (e == "open") {
				this.numType = true;
				setTimeout(() => {
					window.sessionStorage.removeItem("operationKey");
					this.numType = false;
				}, 1800000);
			}
		},
		//调起字组件的操作密码框
		operationShowTime(e) {
			this.operationVisible = true;
		},
		SearchQuestionBankList() {
			this.pages.pageNo = 1;
			this.queryTableData();
		},
		/**
		 * 获取列表
		 */
		async queryTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("/exam/list", {
				params: {
					...this.listParams,
					...this.pages,
				},
				headers: {
					isLoading: true,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			let list = resData.data;
			this.tableData = list;
			this.total = resData.page.count;
		},
		/**
		 * 获取分类列表
		 */
		async classifyData() {
			this.loading = true;

			const { data: resData } = await this.$get("/exam/category/list", {
				params: {
					status: 1,
					paging: false,
					tree: true,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.selectData = resData.data.sort(function (a, b) {
				return b.seq - a.seq;
			});
		},
		/**
		 * 获取说明类型
		 */
		async explainType() {
			this.loading = true;
			const { data: resData } = await this.$get(`/enums/list/EXAM_INTRO_TYPE`);
			this.loading = false;
			if (resData.result != 200) return;
			this.explainTypeData = resData.data;
			this.activeName = resData.data[0].enumVal;
		},
		/**
		 * 获取评测说明列表
		 */
		async explainTableData() {
			this.loading = true;

			const { data: resData } = await this.$get("/exam/intro/list", {
				params: {
					...this.explain,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data) {
				this.explainData = resData.data.sort(function (a, b) {
					return b.seq - a.seq;
				});
			} else {
				this.explainData = resData.data;
			}
		},
		/**
		 * 修改评测题库状态
		 */
		async changeSwitch(b) {
			const { data: resData } = await this.$put(
				`/exam/info/status/${b.examId}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			this.$message({
				message: resData.message,
				type: "success",
			});
		},
		handleNodeClick: function (node) {
			this.dictDataSelect = node.name;
			this.listParams.categoryId = node.categoryId;
			if (node.parentId == 0) {
				this.listParams.parentId = node.categoryId;
			} else {
				this.listParams.parentId = node.categoryId;
			}
			if (node.id != 0) {
				//this.AccountData.orgId = node.id;
			}
			this.$refs.selectReport.blur();
		},
		handleNodeClick1: function (node) {
			this.dictDataSelect1 = node.name;
			this.params.categoryId = node.categoryId;
			this.$refs.selectReport.blur();
		},

		getPolicy() {
			this.$refs.file.dispatchEvent(new MouseEvent("click"));
		},
		async getFile() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.file.files[0],
				resData.data,
				"one", //'more','one'
				this.srcList
			);
			this.isMoer = false;
			this.srcList = addRoutes;
			this.params.logo = this.srcList[0];
		},

		getPolicyLang() {
			this.$refs.fileLang.dispatchEvent(new MouseEvent("click"));
		},
		async getFileLang() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.fileLang.files[0],
				resData.data,
				"one", //'more','one'
				this.srcListLang
			);
			this.isMoerLang = false;
			this.srcListLang = addRoutes;
			this.params.logo2 = this.srcListLang[0];
		},

		getPolicyVideo() {
			this.$refs.fileVideo.dispatchEvent(new MouseEvent("click"));
		},
		async getFileVideo() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});
			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.fileVideo.files[0],
				resData.data,
				"one", //'more','one'
				this.srcListVideo
			);
			this.isMoerVideo = false;
			this.srcListVideo = addRoutes;

			this.params.video = this.srcListVideo[0];
		},

		getPolicyBanner() {
			this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
		},
		async getFileBanner() {
			const that = this;
			const { data: resData } = await this.$get("/aliyun/oss/sign", {
				headers: {
					isLoading: true,
				},
			});

			if (resData.result != 200) return;
			const addRoutes = await ossUpload(
				that.$refs.fileBanner.files[0],
				resData.data,
				"more", //'more','one'
				this.srcListBanner
			);
			this.isMoerBanner = false;
			this.srcListBanner = addRoutes;
			this.params.banners = this.srcListBanner;
		},

		removeUploading(index) {
			this.srcListBanner.splice(index, 1);
			this.params.banners = this.srcListBanner;
		},

		/**
		 * 表格按钮点击
		 */
		async handleClick(type, row = {}) {
			this.clickType = type;
			this.explainParams = {};
			if (type == "edit") {
				this.srcListLang = [];
				this.srcList = [];
				this.isMoer = true;
				this.isMoerLang = true;
				this.params = JSON.parse(JSON.stringify(row));
				this.getExamDataInfo();
			} else if (type == "add") {
				row.vipFree = 1;
				row.recomVip = 1;
				row.resultStatus = 1;
				row.isHot = 0;
				row.isRecommended = 0;
				row.isBanner = 0;
				this.flag = false;
				this.$nextTick(() => {
					this.flag = true; //组件生命重新加载
				});
				this.params = JSON.parse(JSON.stringify(row));
				this.dialogVisible = true;
			} else if (type == "explain") {
				this.dialogVisibleExplain = true;
				this.examInfoId = row.examInfoId;
				/* 获取  第一项 */
				this.explainType();
				this.explain.introType = this.explainTypeData[0].enumVal;
				this.explain.examInfoId = this.examInfoId;
				this.explainTableData();
			} else if (type == "explainAdd") {
				this.explainParams.intro = "";
				this.explainParams = {};
				setTimeout(() => {
					this.innerVisible = true;
				}, 500);
			} else if (type == "explainEdit") {
				const { data: resData } = await this.$get(
					`/exam/intro/info/${row.examIntroId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				if (!resData.data.name) {
					resData.data.name = "";
				}
				this.explainParams = resData.data;
				if (!resData.data.name) {
					this.explainParams.name = JSON.parse(
						JSON.stringify(resData.data.introTypeName)
					);
				}
				this.innerVisible = true;
			} else if (type == "style") {
				this.dialogVisibleStyle = true;
				this.paramsClass.class = row.categoryName;
				this.paramsClass.name = row.name;
				this.paramsClass.iden = row.examId;
				this.appraisalStyle(); /* 已经关联的样式 */
			} else if (type == "ziyuan") {
				this.$router.push({
					name: "zy_LIST",
					query: {
						examId: row.examId,
					},
				});
			} else if (type == "topic") {
				if (row.scheme == "dwrg") {
					this.$router.push({
						name: "DW_List",
						query: {
							examId: row.examId,
						},
					});
				} else {
					if (row.scheme == "jz") {
						this.$router.push({
							name: "JZ_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "aqsy") {
						this.$router.push({
							name: "AQSY_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "wdpj") {
						this.$router.push({
							name: "WDPJ_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "wdsc") {
						this.$router.push({
							name: "WDSC_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "qys") {
						this.$router.push({
							name: "QYS_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "jzqx") {
						this.$router.push({
							name: "JZQX_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "rgtp") {
						this.$router.push({
							name: "RGTP_List",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "ahrg") {
						this.$router.push({
							name: "AHRG_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "ejwz") {
						this.$router.push({
							name: "EJWD_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "tcrg") {
						this.$router.push({
							name: "TCRG_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "mbti") {
						this.$router.push({
							name: "MBTI_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "wdnl") {
						this.$router.push({
							name: "WD_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "wdzh") {
						this.$router.push({
							name: "WDZH_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "rgml") {
						this.$router.push({
							name: "RGML_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "mjywl") {
						this.$router.push({
							name: "MJYWL_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "tzfg") {
						this.$router.push({
							name: "TZFG_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "xltp") {
						this.$router.push({
							name: "XLTP_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else if (row.scheme == "stfsy") {
						this.$router.push({
							name: "STFSY_LIST",
							query: {
								examId: row.examId,
							},
						});
					}  else if (row.scheme == "xlsy") {
						this.$router.push({
											name: "XLSY_LIST",
											query: {
											examId: row.examId,
											},
										});
					} else if(row.scheme == "niq"){
						this.$router.push({
							name: "NIQ_LIST",
							query: {
								examId: row.examId,
							},
						});
					} else{
						this.$router.push({
							name: "WD_LIST",
							query: {
								examId: row.examId,
							},
						});
					}
				}
			} else if (type == "time") {
				this.$confirm("确定对当前时间进行操作?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						const { data: resData } = this.$put(
							`/exam/info/issued/time/${row.examId}`,
							{
								headers: {
									isLoading: true,
								},
							}
						);

						if (resData.result != 200) return;
						this.queryTableData(); ///RENEW
						this.$message.success(resData.message);
					})
					.catch(() => {});
			} else if (type == "grouping") {
				this.$router.push({
					name: "GROUPING",
					query: {
						examId: row.examId,
					},
				});
			} else if (type == "programme") {
				this.$router.push({
					name: "SCHEME_GROUPING",
					query: {
						examId: row.examId,
					},
				});
			}
		},

		//获取测评题目详情内容
		getExamDataInfo() {
			this.$get(`/exam/info/${this.params.examId}`, {
				headers: {
					"Language-Code": this.languageCode,
				},
			}).then((res) => {
				let temp = res.data.data;
				if (emptyShow(temp.logo)) {
					this.srcList.push(temp.logo);
					this.isMoer = false;
				}
				if (emptyShow(temp.logo2)) {
					this.srcListLang.push(temp.logo2);
					this.isMoerLang = false;
				}
				if (emptyShow(temp.banners)) {
					this.srcListBanner = temp.banners; //轮播图
					this.isMoerBanner = true;
				}
				if (emptyShow(temp.video)) {
					this.video = temp.video; //视频
					this.isMoerVideo = false;
				}
				this.flag = false;
				this.$nextTick(() => {
					this.flag = true; //组件生命重新加载
				});
				let newarr = JSON.parse(JSON.stringify(temp));
				newarr.payPrice = temp.payPrice / 100;
				newarr.rawPrice = temp.rawPrice / 100;
				this.params = newarr;
				this.dictDataSelect1 = temp.categoryName;
				this.dialogVisible = true; //编辑
			});
		},

		/**
		 * 编辑/新增
		 */
		handleEdit() {
			let b = this.params.payPrice * 100;
			let c = b.toFixed(1);
			let rawb = this.params.rawPrice * 100;
			let rawc = rawb.toFixed(1);
			this.$refs.ruleForm.validate((valid) => {
				if (!valid) return;
				this.$confirm("确认保存数据, 是否继续?", "提示", {
					type: "info",
				}).then(async () => {
					this.params.payPrice = parseInt(c);
					this.params.rawPrice = parseInt(rawc);
					if (this.clickType == "add") {
						const { data: resData } = await this.$post(
							"/exam/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.queryTableData();
						this.srcListLang = [];
						this.srcList = [];
						this.isMoer = true;
						this.isMoerLang = true;
						this.params.examId = resData.data;
						this.getExamDataInfo();
						this.$message.success("添加成功!");
						this.params = {};
						this.clickType = "edit";
					} else if (this.clickType == "edit") {
						const { data: resData } = await this.$put(
							"/exam/info",
							this.params,
							{
								headers: {
									isLoading: true,
									"Language-Code": this.languageCode,
								},
							}
						);
						if (resData.result != 200) return;
						this.queryTableData();
						this.srcListLang = [];
						this.srcList = [];
						this.isMoer = true;
						this.isMoerLang = true;
						this.params.examId = resData.data;
						this.getExamDataInfo();
						this.$message.success("修改成功!");
					}
				});
			});
		},
		select(e) {
			if (!this.explainParams.name) {
				this.explainTypeData.map((item) => {
					if (item.enumVal == e) {
						this.explainParams.name = JSON.parse(JSON.stringify(item.enumName));
					}
				});
			}
		},
		/**
		 * 说明编辑/新增
		 */
		handleExplainEdit() {
			// explainParams.intro
			this.$refs.explainRuleForm.validate((valid) => {
				if (!valid) return;
				if (this.explainParams.seq) {
					this.explainParams.examInfoId = this.examInfoId;
					this.$confirm("确认保存数据, 是否继续?", "提示", {
						type: "info",
					}).then(async () => {
						if (this.clickType == "explainAdd") {
							const { data: resData } = await this.$post(
								"/exam/intro/info",
								this.explainParams,
								{
									headers: {
										isLoading: true,
									},
								}
							);

							if (resData.result != 200) return;

							this.explainTableData();

							this.innerVisible = false;

							this.$message.success("添加成功!");
							this.explainParams = {};
						}
						if (this.clickType == "explainEdit") {
							this.explainParams.examInfoId = this.examInfoId;
							const { data: resData } = await this.$put(
								"/exam/intro/info",
								this.explainParams,
								{
									headers: {
										isLoading: true,
									},
								}
							);

							if (resData.result != 200) return;

							this.explainTableData();

							this.innerVisible = false;

							this.$message.success("修改成功!");
						}
					});
				} else {
					this.$message.success("请填写排序");
				}
			});
		},

		/**
		 * 删除
		 */
		handleDelete(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/exam/info/${row.examId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.queryTableData();
				this.$message.success("删除成功!");
			});
			this.clearStore();
		},
		/**
		 * 说明删除
		 */
		handleDeleteexplain(row) {
			this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
				type: "warning",
			}).then(async () => {
				const { data: resData } = await this.$delete(
					`/exam/intro/info/${row.examIntroId}`,
					{
						headers: {
							isLoading: true,
						},
					}
				);
				if (resData.result != 200) return;
				this.explainTableData();

				this.$message.success("删除成功!");
			});
			this.clearStore();
		},

		handleClickExplain(tab, event) {
			this.explain.introType = tab.name;
			this.explainTableData();
		},

		// 获取已经关联样式id
		async queryStyleData() {
			this.loading = true;
			const { data: resData } = await this.$get("/exam/style/list", {
				params: {
					...this.listParams,
				},
			});
			this.loading = false;
			if (resData.result != 200) return;
			this.tableDataStyle = resData.data.sort(function (a, b) {
				return b.seq - a.seq;
			});
		},

		/*左右 切换样式 */
		handleClickStyle(tab, event) {
			this.activeIndex =
				tab.name == "cpzy" ? this.tempStyle.main : this.tempStyle.res; //相应切换到 index
			this.listParams.styleType = tab.name;
			this.listParams.examId = this.paramsClass.iden;
			// this.explainType();

			this.appraisalStyle();
			this.queryStyleData(); /* 已经关联的样式 */
		},

		/* 点击下面的样式 */
		selectStyle(item, index) {
			var that = this;
			// 将点击的是谁 存起来
			if (this.paramsClass.styleType == "cpzy") {
				this.tempStyle.main = index;
				this.activeIndex = this.tempStyle.main;
			} else {
				this.tempStyle.res = index;
				this.activeIndex = this.tempStyle.res;
			}

			item.examId = this.paramsClass.iden;
			/* 关联样式 */
			this.$post("/exam/info/style", {
				examId: item.examId,
				examStyleId: item.examStyleId,
				styleType: this.paramsClass.styleType,
			}).then((res) => {
				if (res.data.result == 200) {
					that.$message.success("关联成功");
				} else {
					that.$message.warning(res.message);
				}
			});
		},

		/**
		 * 获取  打开弹窗 关联的 测评样式
		 */
		async appraisalStyle() {
			this.loading = true;
			const { data: resData } = await this.$get(
				`/exam/info/style/${this.paramsClass.iden}/${this.paramsClass.styleType}`
			);
			this.loading = false;
			if (resData.result != 200) return;
			if (resData.data == undefined) return;

			if (this.paramsClass.styleType == "cpzy") {
				this.tempStyle.main = resData.data.examStyleId;
			} else {
				this.tempStyle.res = resData.data.examStyleId;
			}
			this.activeIndex = resData.data.examStyleId;
		},

		/**
		 *  分页长度改变
		 */
		handleSizeChange(val) {
			this.pages.pageNo = 1;
			this.pages.pageSize = val;
			this.queryTableData();
		},
		/**
		 *  下一页
		 */
		handleCurrentChange(val) {
			this.pages.pageNo = val;
			this.queryTableData();
		},
	},
};
</script>
<style lang="scss" scoped>
.item_info {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
}

.name_left {
	width: 60px;
	text-align: right;
}

.diplay {
	display: inline-block;
}

.screenshot {
	display: inline-block;
	vertical-align: text-top;
}

.video-label {
	margin-right: 15px;
}

.item-add {
	margin: 15px 0;

	.el-button {
		margin-bottom: 15px;
	}

	.el-button img {
		max-height: 12px;
	}
}

.style_box {
	display: flex;
	flex-wrap: wrap;
}

.style-outer {
	background: #fff;
	//float: left;
	margin: 0 20px 20px 0;
	width: 108px;
	//height: 110px;
	border: 1px solid #ddd;
	cursor: pointer;
	position: relative;

	.style__font {
		padding: 0 5px;
		line-height: 1.5;
		//line-height: 5px;
		//margin: 0 0 0 10px;
	}

	.isCheck {
		position: absolute;
		top: 0;
		right: 5px;
		z-index: 2;

		.el-icon-success {
			font-size: 20px;
			color: #ddd;
		}
	}
}

.active_class {
	// border: 1px solid #000 !important;
	color: #67c23a !important;
}
</style>
